import { ActionTree } from 'vuex'
import { RootState } from '../types'
import { profile } from '@/api/user'
import { AxiosResponse } from 'axios'
import { AuthState, User } from './types'

export const actions: ActionTree<AuthState, RootState> = {
  pullProfile ({ commit }): void {
    profile().then((response: AxiosResponse) => {
      const user: User = response.data
      commit('refreshProfile', user)
    })
  }
}
